export default {
    props: {
        message: {
            default: ""
        },
        defaultExpandedKeys: {
            default: () => {
                return [1];
            }
        }
    },
    data() {
        return {
            defaultProps: {
                children: 'List',
                label: 'D_Name'
            },
            loading: false
        }
    },
    computed: {
        DataList() {
            if (this.message.length > 0) {
                this.loading = false;
            } else {
                this.loading = true;
            }
            return this.message;
        }
    },
    methods: {
        handleNodeClick(value) {
            this.$emit('NodeClick', value)
        },
    },
}


// WEBPACK FOOTER //
// ./src/common/components/Tree/vm.js